import TicketsPage from '../../../tickets/TicketsPage'

export default TicketsPage
